// @vendors
const Immutable = require('immutable');

// @utilities
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    ACTIVE_CLASS_MONEY_MARKET_ID,
    ACTIVE_CLASS_FIXED_INCOME_ID,
    ACTIVE_CLASS_EQUITY_ID,
    ACTIVE_CLASS_REAL_ASSETS_ID,
} = require('../raConstants/index');

function getAssetClassName(assetClassId) {
    return formatText(`raGlobal-raGlobal_asset${assetClassId}`);
}

function getEmptyStateAssets() {
    return [
        {
            assetClassId: ACTIVE_CLASS_MONEY_MARKET_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_MONEY_MARKET_ID),
            weight: 0,
        },
        {
            assetClassId: ACTIVE_CLASS_FIXED_INCOME_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_FIXED_INCOME_ID),
            weight: 0,
        },
        {
            assetClassId: ACTIVE_CLASS_EQUITY_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_EQUITY_ID),
            weight: 0,
        },
        {
            assetClassId: ACTIVE_CLASS_REAL_ASSETS_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_REAL_ASSETS_ID),
            weight: 0,
        },
    ];
}

function getEmptyPieAssets() {
    const emptyData = Immutable.List([
        {
            key: ACTIVE_CLASS_MONEY_MARKET_ID,
            label: getAssetClassName(ACTIVE_CLASS_MONEY_MARKET_ID),
            value: 0,
        },
        {
            key: ACTIVE_CLASS_FIXED_INCOME_ID,
            label: getAssetClassName(ACTIVE_CLASS_FIXED_INCOME_ID),
            value: 0,
        },
        {
            key: ACTIVE_CLASS_EQUITY_ID,
            label: getAssetClassName(ACTIVE_CLASS_EQUITY_ID),
            value: 0,
        },
        {
            key: ACTIVE_CLASS_REAL_ASSETS_ID,
            label: getAssetClassName(ACTIVE_CLASS_REAL_ASSETS_ID),
            value: 0,
        },
    ]);
    return emptyData;
}

function getBarColor(assetClassId) {
    const assetsIds = {
        [ACTIVE_CLASS_MONEY_MARKET_ID]: '#405CD6',
        [ACTIVE_CLASS_FIXED_INCOME_ID]: '#0C9FAC',
        [ACTIVE_CLASS_EQUITY_ID]: '#DD2774',
        [ACTIVE_CLASS_REAL_ASSETS_ID]: '#6C960A',
    };

    return assetsIds[assetClassId] || '';
}

const assetClassPGMap = {
    'Mercado monetario': ACTIVE_CLASS_MONEY_MARKET_ID,
    'Renta fija': ACTIVE_CLASS_FIXED_INCOME_ID,
    'Renta variable': ACTIVE_CLASS_FIXED_INCOME_ID,
    'Activos reales': ACTIVE_CLASS_REAL_ASSETS_ID,
};

module.exports = {
    assetClassPGMap,
    getAssetClassName,
    getEmptyPieAssets,
    getEmptyStateAssets,
    getBarColor,
};
